import { render, staticRenderFns } from "./NewAppNotification.vue?vue&type=template&id=af03c302"
import script from "./NewAppNotification.vue?vue&type=script&lang=js"
export * from "./NewAppNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports